import { HttpMethod } from '../../definition';
import { useBaseQuery } from '../../http';
import { useWorkspace } from '../../workspace';
import { GET_SOCKET_TOKEN } from '../../workspace/constants/endpoints';
import { SOCKET_ENABLED } from '../constants';
import { GetTokenApiResponse } from '../types';

export function useGetSocketToken() {
  const workspaceId = useWorkspace()?.id;

  return useBaseQuery<never, GetTokenApiResponse>(
    [useGetSocketToken.name],
    {
      url: GET_SOCKET_TOKEN.replace(':wid', String(workspaceId)),
      method: HttpMethod.get,
    },
    {
      enabled: SOCKET_ENABLED,
    }
  );
}
